"use client";

import { ErrorPage } from "@shared/components/ErrorPage";

export default function MarketingError(props: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return <ErrorPage {...props} />;
}
